import { render, staticRenderFns } from "./complaintsRecord.vue?vue&type=template&id=f3f3ad9e&scoped=true"
import script from "./complaintsRecord.vue?vue&type=script&lang=js"
export * from "./complaintsRecord.vue?vue&type=script&lang=js"
import style0 from "./complaintsRecord.vue?vue&type=style&index=0&id=f3f3ad9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f3ad9e",
  null
  
)

export default component.exports